"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBookings = void 0;
const axios_1 = __importDefault(require("axios"));
async function getBookings(accountId, params = {}) {
    console.log('getBookings:accountId, params', accountId, params);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `/bookings-api/bookings/${accountId}`,
        params
    });
    return resp.data;
}
exports.getBookings = getBookings;
